import { Avatar, Stack, Typography } from '@mui/material';
import { deleteRecommendation } from 'API/Home/recommendations';
import { NextPrevButton } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useLoader } from 'Hooks/useLoader';
import { OpenTrashBin, Trash } from 'Images';
import { useEffect } from 'react';

interface IDeleteRequest {
  path: string;
  body: {
    reqNumber: string;
    nextEntitleDate: Date;
  };
}

interface IDeleteRecommendation {
  animationHandler: Function;
  removeRecommendation: Function;
  deleteRequest: IDeleteRequest;
}

export const DeleteRecommendation = ({
  animationHandler,
  removeRecommendation,
  deleteRequest,
}: IDeleteRecommendation) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Home
  ).userRecommendations;

  const { isLoading, setIsLoading, loader } = useLoader(
    undefined,
    { height: 'fit-content' },
    50
  );

  useEffect(() => {
    setIsLoading(false); //Unmounted handler
  }, [setIsLoading]);

  const deleteRecommendationHandler = async () => {
    setIsLoading(true);
    const result = await deleteRecommendation(
      deleteRequest.body,
      deleteRequest.path
    );
    if (result) removeRecommendation(result.reqNumber);
    setIsLoading(false);
  };

  return (
    <>
      <Stack alignItems='center' gap='12px'>
        <Avatar
          alt=''
          src={OpenTrashBin}
          sx={{ width: '50px', height: '50px' }}
        />
        <Typography variant='body6'>
          {dictionary.deleteRecommendation}
        </Typography>
      </Stack>
      <Stack
        direction='row'
        justifyContent='space-evenly'
        sx={{
          mt: '24px',
        }}
      >
        {isLoading ? (
          loader
        ) : (
          <>
            <NextPrevButton
              text={dictionary.dontDelete}
              callback={() => animationHandler(true)}
              style={{
                button: {
                  width: '121px',
                  whiteSpace: 'nowrap',
                },
              }}
            />
            <NextPrevButton
              isBlue
              hideArrowIcon
              text={dictionary.delete}
              callback={() => deleteRecommendationHandler()}
              style={{
                button: {
                  width: '121px',
                  whiteSpace: 'nowrap',
                },
              }}
              icon={{
                src: Trash,
                sx: {
                  width: '16px',
                  height: '16px',
                },
              }}
            />
          </>
        )}
      </Stack>
    </>
  );
};
